import { defineMessages } from 'react-intl';

export default defineMessages({
  editContent: 'Edit {type}',

  textTitle: 'Name',
  textTitlePlaceholder: 'Enter a descriptive name for this text block',
  textTitleRequired: 'Name is required',
  textBody: 'Text',
  textBodyRequired: 'Text cannot be empty.',
  textBodyPlaceholder: 'Enter formatted text',

  blockTitle: 'Block title',
  blockTitleRequired: 'Block title is required!',
  blockTitlePlaceholder: 'Enter a descriptive title for this block',

  questionDetails: 'Details',
  questionGroup: 'Group',
  questionGroupInfo: 'Manage the relations and translations between this question and the corresponding questions in the survey group. The relation is used to combine the results. A question can only be part of one group so if you connect it here, it will be removed from its previous group (if any). Only questions of the same type can be connected.',
  defaultNPStitle: 'How likely would you be to recommend our website?',
  questionTitle: 'Question',
  questionTitleRequired: 'Question is required',
  questionTitlePlaceholder: 'Enter a question',
  questionDescription: 'Description',
  questionDescriptionPlaceholder: 'Explanatory description',
  required: 'Required',
  resultsCollection: 'Result tab',
  resultsCollectionPlaceholder: 'Choose where your question should be displayed in the results',
  resultsCollectionRequired: 'Result tab is required',
  questionTags: 'Extra settings',

  type: 'Type',
  subType: 'Answer field style',
  TEXTAREA: 'Text area',
  TEXT: 'Input field',
  NUMBER: 'Number field',
  EMAIL: 'Email field',
  rowCount: 'Number of rows',

  options: 'Options',
  addOptionPlaceholder: 'Add new option',
  addOptionTooltip: 'Press enter to add a new option',
  removeOptionTitle: 'Remove option',
  removeOptionHasResponses: '"{option}" has {responseCount} responses, you can only hide it.',
  removeOptionNoResponses: 'Do you really want to remove "{option}"?',
  emptyOptions: 'Options will appear here when added',
  option: 'Option',
  value: 'Value',
  optionTitleRequired: 'Option title for row {row} is missing',
  advancedSettings: 'More option settings',
  minAnswers: 'Min number of answers',
  maxAnswers: 'Max number of answers',
  maxLength: 'Max number of characters',
  randomize: 'Shuffle option order',
  lockLastOption: 'Dont shuffle the last option',
  dependencyAdd: 'Add display rule',
  dependencyRemove: 'Remove rule',
  dependencyQuestionLabel: 'Only show if question',
  dependencyQuestionPlaceholder: 'Choose a question',
  dependencyAnswerLabel: 'Is answered with',
  dependencyOptionPlaceholder: 'Choose one or more answers',
  dependencyAnswerPlaceholder: 'Enter text to match',
  dependencyCountryPlaceholder: 'Choose a country',
  dependencyOperator: 'Combine rules with',
  dependencyOperatorAnd: 'And - All of the rules must match',
  dependencyOperatorOr: 'Or - One of the rules must match',
});
